module.exports = __webpack_public_path__ + "static/img/followlist.17e5e743.png";